import InvoiceListTableProvider from './InvoiceListTableProvider'
import Table, { TableHeader, TableHeaderWithFieldId } from '../shared/Table'
import { DataType } from '../../services/CompanyService';
import { TranslationService } from '../../services/TranslationService';
import { useCallback } from 'react';
import { formatNumber } from '../../utils/FormatUtils';
import iconInvoice from "../../assets/img/icon-invoice.svg";
import FileService from '../../services/FileService';
import { ListItemInvoice } from '../account/entities/AccountResponse';

export const InvoiceListDataPlan = () => {
    const tableHeaders: TableHeaderWithFieldId[] = [
        {
            ...new TableHeader("file", '', false, false, ""),
            fieldId: "file",
            type: DataType.Text,
        },
        {
            ...new TableHeader("date", TranslationService.translate.Date, false, false, "w-25"),
            fieldId: "date",
            type: DataType.Text,
        },
        {
            ...new TableHeader("number", TranslationService.translate.Number, false, false, "text-end"),
            fieldId: "number",
            type: DataType.Number,
        },
        {
            ...new TableHeader("amount", TranslationService.translate.Value, false, false, "w-25 text-end"),
            fieldId: "amount",
            type: DataType.Text,
        },
        {
            ...new TableHeader("status", TranslationService.translate.Status, false, false, "w-100"),
            fieldId: "status",
            type: DataType.Text,
        },
    ];

    return (
        <div className="card-body">
            <InvoiceListTableProvider>
                <Table headers={tableHeaders}
                    item={InvoiceTableItem}
                    stickyHeader={true}>
                </Table>
            </InvoiceListTableProvider>
        </div>
    )
}

const InvoiceTableItem = ({ data }: { data: ListItemInvoice }) => {
    const statusCode = (status: number) => {
        switch (status) {
            case 1:
                return <span className="w-md status-text status-paid-text">
                    {TranslationService.translate.Paid}
                </span>
            default:
                return <span className="w-md status-text status-pending-text">
                    {TranslationService.translate.PendingPayment}
                </span>
        }
    }
    const date = new Date(data.date);

    const formatted = date.toLocaleDateString(TranslationService.currentLanguage, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: "UTC",
    });

    const formattedDate = formatted ?? "";
    const downloadFileInvoice = useCallback(() => data?.invoiceId && FileService.downloadInvoice(data.invoiceId.toString()), [data.invoiceId])

    return (
        <tr>
            <td className='text-center pointer'>
                <span onClick={downloadFileInvoice}>
                    <img src={iconInvoice} alt={'Download Invoice'} />
                </span>
            </td>
            <td>
                <span className="w-md">
                    {formattedDate}
                </span>
            </td>
            <td className="text-end">
                <span className="w-md">
                    {data?.number.toString()}
                </span>
            </td>
            <td className="text-end">
                <span className="w-md">
                    {data?.currencyCode} {formatNumber(data?.amount)}
                </span>
            </td>
            <td>
                {statusCode(data?.status)}
            </td>
        </tr>
    )
}